export default "__VITE_ASSET__BNUwM14o__"